import { render } from "./index.vue?vue&type=template&id=496bf545"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabApp/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "496bf545"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('496bf545', __exports__)) {
    api.reload('496bf545', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=496bf545", () => {
    api.rerender('496bf545', render)
  })

}


export default __exports__